import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBooking, setDeactive, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import White from "../../../Assets/images/white-bg.avif"
import Compressor from 'compressorjs';
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import Modal from "../../../Helpers/Components/Modal";

const Pending = (props) => {
    const dispatch = useDispatch()
    const booking = useSelector(state => state?.booking?.booking)
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const setSteps = () => {
        dispatch(setStep(3))
    }
    const handleNext = () => {
        if (!booking?.pendingPhoto?.length) {
            toast.error("Pending photo is required")
        } else {
            props?.setPreview(true)
        }
    }
    const setPreview = () => {
        if (!booking?.pendingPhoto?.length) {
            toast.error("Atleast one pending is required")
        } else if (!booking?.formPhoto) {
            toast.error("Form photo is required")
        } else {
            setModal(true)
        }
    }
    const checkFileSize = async (file, form) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            if (form) {
                setLoading(true)
                const response = await Handler({ method: 'patch', url: `/booking/details/form/photo/${props?.bookingId}`, data: { formPhoto: file }, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    dispatch(setBooking({ formPhoto: response?.data }))
                } else {
                    toast.error("Unable to upload photo")
                }
                setLoading(false)
            } else {
                const value = Array.isArray(booking?.pendingPhoto) ? booking.pendingPhoto : [];
                const updatedValue = [...value, { url: URL.createObjectURL(file), file: file }];
                dispatch(setBooking({ pendingPhoto: updatedValue }));
            }
        }
    };
    const compressImage = (file, form) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, form);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, form) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], form);
        }
    };
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-lg-6">

                    <label htmlFor="leadMode" className="form-label d-block mb-2">Pending Photos </label>
                    {
                        booking?.pendingPhoto?.length ?
                            booking?.pendingPhoto?.map((element, i) => {
                                return (
                                    <div className="row" key={i}>
                                        <div className="col-md-8 col-lg-12 col-xl-8 mt-3 mt-md-0">
                                            <div className="mb-3">
                                                <div className="main-div">
                                                    <img src={element?.url || White} alt="Pending" className="kycPhotoImg" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            : ""
                    }
                    <label htmlFor="pending"><i className="fa-solid fa-plus cursor-pointer fs-5"></i></label>
                    <input type="file" accept="image/*" className="d-none" name="pending" id="pending" onChange={(e) => { handleImage(e) }} />

                </div>
                <div className="col-lg-6">
                    <div className="mb-3 col-md-8 col-lg-12 col-xl-8">
                        <label htmlFor="formPhoto" className="form-label"> Form Photo </label>
                        <div className="main-div">
                            <div className="btn-div"><label htmlFor="formPhoto" className="me-2 upload-btn">Upload</label></div>
                            <input type="file" accept="image/*" className="d-none" name="formPhoto" id="formPhoto" disabled={loading} onChange={(e) => { handleImage(e, "formPhoto") }} />
                            <img src={booking?.formPhoto || White} alt="Form" className="kycPhotoImg" />
                        </div>
                    </div>
                </div>
            </div>
            <Modal header="Approval" onShow={modal} toggle={() => setModal(false)} overlayToggle={() => setModal(false)}>
                <div className="px-4">
                    <div className="mb-3 fw-medium">Do you want to deactive this car {booking?.carId}? </div>
                    <div className="text-center mt-4">
                        <button className="btn btn-success" disabled={loading} onClick={() => { dispatch(setDeactive(true)); setModal(false); props?.setPreview(true) }}>Yes</button>
                        <button className="btn btn-danger ms-2" disabled={loading} onClick={() => { dispatch(setDeactive(false)); setModal(false); props?.setPreview(true) }}>No</button>
                    </div>
                </div>
            </Modal>
            <NextPrev step={4} setStep={setSteps} last={3} onClick={handleNext} loading={loading} />
            <div className="text-center mt-4"><button className="btn btn-theme" disabled={loading} onClick={() => { setPreview() }}>Preview</button></div>
        </React.Fragment>
    )
}

export default Pending;
